import enviro from 'enviro';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { NavMarker } from 'react-rhumb';
import ViralLink from 'viral-links-lib/viral-link/ViralLink';
import { useLocation } from 'react-router-dom';
import { getPortalIdFromUrl } from '../utils/urls';
import { Flow } from 'signup-constants/Flow';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Meetings() {
  const location = useLocation();
  const portalId = getPortalIdFromUrl();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MEETINGS_LINK_LOADED",
    children: /*#__PURE__*/_jsx(ViralLink, {
      portalId: portalId || undefined,
      viralLinkType: location.pathname.substring(1),
      environment: enviro.getShort(),
      flow: Flow.Sales,
      use: "primary",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "app.viralLinks.meetings.linkCta"
      })
    })
  });
}